<res-base-modal [modalTitle]="'New Project'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'Create Project'" (primaryButtonActionEmt)="ok()" [isPrimaryBtnEnabled]="okEnabled()"
    (closeButtonActionEmt)="modalOpened=false;closeModal()" [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [verifyRequiredValidator]="true" [modalHelpIndex]="modalHelpIndex"
    [modalDraggable]=false>

    <div class="project-info">
        <res-name-description [automationId]="modalAutomationId" [validateName]="true"
            [validateNameRequest]="validateNameRequest" [customLabelWidth]="'110'">
        </res-name-description>
        <div class="project-setup">
            <div>
                <label>Review System:</label>
            </div>
            <div class="button-group">
                <button [attr.data-automation-id]="modalAutomationId + '-digital-reef-only-button'" type="button"
                    [ngClass]="reviewSystem === reviewSystemEnum.NONE ? 'btn-group-active' : 'btn-group-default'"
                    (click)="onChange(reviewSystemEnum.NONE)" [disabled]="(selectedReviewProjects.length > 0 && !autoGenerate) && reviewSystem !== reviewSystemEnum.NONE">
                    <div>Reef ECA Only</div>
                    <i class="fa fa-caret-up up-caret-active" [hidden]="reviewSystem !== reviewSystemEnum.NONE"></i>
                </button>
                <button [attr.data-automation-id]="modalAutomationId + '-reef-review-button'" type="button"
                    [ngClass]="reviewSystem === reviewSystemEnum.REEF_REVIEW ? 'btn-group-active' : 'btn-group-default'"
                    (click)="onChange(reviewSystemEnum.REEF_REVIEW)"  [disabled]="(selectedReviewProjects.length > 0 && !autoGenerate) && reviewSystem !== reviewSystemEnum.REEF_REVIEW">
                    <div>Reef Review</div>
                    <i class="fa fa-caret-up up-caret-active"
                        [hidden]="reviewSystem !== reviewSystemEnum.REEF_REVIEW"></i>
                </button>
                <button [attr.data-automation-id]="modalAutomationId + '-relativity-server-button'" type="button"
                    [ngClass]="reviewSystem === reviewSystemEnum.RELATIVITY ? 'btn-group-active' : 'btn-group-default'"
                    (click)="onChange(reviewSystemEnum.RELATIVITY)"  [disabled]="(selectedReviewProjects.length > 0 && !autoGenerate) && reviewSystem !== reviewSystemEnum.RELATIVITY">
                    <div>Relativity Server</div>
                    <i class="fa fa-caret-up up-caret-active"
                        [hidden]="reviewSystem !== reviewSystemEnum.RELATIVITY"></i>
                </button>
                 <!-- <button [attr.data-automation-id]="modalAutomationId + '-relativity-one-button'" type="button"
                    [ngClass]="reviewSystem === reviewSystemEnum.RELATIVITY_ONE ? 'btn-group-active' : 'btn-group-default'"
                    (click)="onChange(reviewSystemEnum.RELATIVITY_ONE)" disabled="true">
                    <div>Relativity One</div>
                    <i class="fa fa-caret-up up-caret-active"
                        [hidden]="reviewSystem !== reviewSystemEnum.RELATIVITY_ONE"></i>
                </button>          -->
            </div>
        </div>
        <div class="project-setup" *ngIf="reviewSystem !== reviewSystemEnum.NONE">
            <div>
                <label requiredAsterisk>Review Project:</label>
            </div>
            <div class="radio-button-group fill-width">
                <res-custom-radio-button [(ngModel)]="autoGenerate" content="New" class="new-radio"
                    [automationId]="modalAutomationId + '-review-project-new'" name="autoGenerate" [value]="true">
                </res-custom-radio-button>
                <div class="existing-radio-combo-box">
                    <res-custom-radio-button [automationId]="modalAutomationId + '-review-project-existing'"
                        requiredAsterisk class="existing-radio right-margin" [(ngModel)]="autoGenerate" [isRequired]="!autoGenerate"
                        content="Existing:" name="autoGenerate" [value]="false">
                    </res-custom-radio-button>
                    <div class="selected-review-section" [ngClass]="selectedReviewProjects.length > 0 ? 'margin-substracted' :''">
                        <div *ngFor="let reviewProject of selectedReviewProjects" class="selected-review-item" [ngClass]="autoGenerate ? 'disabled-item' : ''"
                            [attr.data-automation-id]="modalAutomationId + '-existing-review-project-' + reviewProject.reviewProject.name">                           
                            <span class="reef-review-icons"
                                [title]="reviewSystem === reviewSystemEnum.RELATIVITY ? 'Reef ECA and Relativity project' : 'Reef ECA and Reef Review project'">
                                <i class="fa fa-clone"
                                    [ngClass]="reviewSystem === reviewSystemEnum.RELATIVITY ? 'relativity-icon-color' : 'reef-review-icon-color'"></i>
                                <span
                                    [ngClass]="reviewSystem === reviewSystemEnum.RELATIVITY ? 'relativity-icon-color' : 'reef-review-icon-color'">R</span>
                            </span>
                            {{reviewProject.reviewProject.name}}
                            <button type="button" class="remove-button" (click)="onRemoveClick(reviewProject)"
                                [attr.data-automation-id]="modalAutomationId + '-existing-review-project-' + reviewProject.reviewProject.name + '-remove-button'">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <button class="secondary-button select-review-item-button" type="button" [disabled]="autoGenerate"
                            (click)="openSelectReviewProjects()"
                            [attr.data-automation-id]="modalAutomationId + '-add-review-project-button'">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="project-setup" *ngIf="reviewSystem === reviewSystemEnum.REEF_REVIEW && autoGenerate">
            <div>
                <label requiredAsterisk>Review Template:</label>
            </div>
            <div class="selected-review-section" [ngClass]="selectedTemplate ? 'margin-substracted':''">
                <div class="selected-review-item template-item" *ngIf="selectedTemplate" 
                    [attr.data-automation-id]="modalAutomationId + '-review-template'">
                    {{selectedTemplate}}
                    <button type="button" class="remove-button" (click)="onTemplateRemoveClick()"
                        [attr.data-automation-id]="modalAutomationId + '-review-template-remove-button'">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <button class="secondary-button select-review-item-button" type="button"
                    (click)="openSelectReviewTemplate()"
                    [attr.data-automation-id]="modalAutomationId + '-edit-review-template-button'">
                    <i class="fa fa-pencil"></i>
                </button>
            </div>
        </div>
        <div *ngIf="isExpressSystem">
            <span class="header"  [attr.data-automation-id]="modalAutomationId + '-reef-express-header'">Reef Express</span>
            <div class="project-setup">
                <div>
                    <label>Project Type:</label>
                </div>
                <div class="radio-button-group">
                    <res-custom-radio-button [(ngModel)]="standardProjectType" content="Standard" (ngModelChange)="onProjectTypeChanged()"
                        [automationId]="modalAutomationId + '-project-type-standard'" name="standardProject" [value]="true">
                    </res-custom-radio-button>
                    <res-custom-radio-button [(ngModel)]="standardProjectType" content="Reef Claims" (ngModelChange)="onProjectTypeChanged()"
                        [automationId]="modalAutomationId + '-project-type-reef-claims'" name="reefClaimsProject" [value]="false">
                    </res-custom-radio-button>
                </div>
            </div>
            <div class="project-setup">
                <res-custom-input-file [disabled]="standardProjectType" [(ngModel)]="logoModel" [createFileMD5]="true"
                    labelText="Project Logo" [automationId]="modalAutomationId + '-project-logo'"
                    typesAccepted="image/jpeg,image/tiff,.bmp,.webp,.svg,.png" sizeLimitInMB="2"
                    deleteMessage="Delete Project Logo?">
                </res-custom-input-file>
            </div>
        </div>
        <div class="group-title">
            <span>Membership</span>
            <button type="button" [attr.data-automation-id]="modalAutomationId + '-add-remove-members-button'"
                class="secondary-button" (click)="editMembers()" [disabled]="genericGrid.isBusy">
                <i class="fa fa-pencil"></i>Add / Remove Members ...
            </button>
        </div>
        <div class="modal-fill members-grid">
            <res-generic-grid gridName="Members" [automationId]="modalAutomationId" [pagerVisible]="false"
                [isBusyOnInit]="true" [rowHeight]="50" [columnDefs]="columnDefs" [gridContext]="gridContext"
                [requestInfo]="requestInfo" [responseCallback]="responseCallback">
            </res-generic-grid>
        </div>
    </div>
    <div class="project-settings">
        <div class="group-title">
            <span>Settings</span>
        </div>
        <div class="modal-fill-auto" [attr.data-automation-id]="modalAutomationId + '-settings-container'"
            [resBusySpinner]="isSettingsBusy" message="Loading Templates ...">
            <div *ngFor=" let templateType of eDiscoveryTemplateTypes | values" class="modal-row">
                <div class="modal-row-column-auto">
                    <label>{{templateType.name}}</label>
                </div>
                <div class="modal-row-column-max">
                    <select [attr.data-automation-id]="templateType.automationId"
                        [(ngModel)]="templateType.selectedTemplate">
                        <optgroup label="Organization Templates:">
                            <option *ngFor="let template of templateType.templates"
                                [hidden]="template.orgId === 'DRSystem'" [ngValue]="template">{{template.name}}</option>
                        </optgroup>
                        <optgroup label="System Templates:"
                            *ngIf="hasSysPermissions && templateType.name !== 'Workflows:'">
                            <option *ngFor="let template of templateType.templates"
                                [hidden]="template.orgId !== 'DRSystem'" [ngValue]="template">{{template.name}}</option>
                        </optgroup>
                    </select>
                </div>
            </div>
            <div class="modal-row horizontal-border" [hidden]="!reviewTemplateTypes"></div>
            <div *ngFor=" let templateType of reviewTemplateTypes | values" class="modal-row">
                <div class="modal-row-column-auto">
                    <label>{{templateType.name}}</label>
                </div>
                <div class="modal-row-column-max">
                    <select [attr.data-automation-id]="templateType.automationId"
                        [(ngModel)]="templateType.selectedTemplate">
                        <optgroup label="Organization Templates:">
                            <option *ngFor="let template of templateType.templates"
                                [hidden]="template.orgId === 'DRSystem'" [ngValue]="template">{{template.name}}</option>
                        </optgroup>
                        <optgroup label="System Templates:">
                            <option *ngFor="let template of templateType.templates"
                                [hidden]="template.orgId !== 'DRSystem'" [ngValue]="template">{{template.name}}</option>
                        </optgroup>
                    </select>
                </div>
            </div>
            <div style="margin-bottom: 10px"></div>
        </div>
    </div>
</res-base-modal>